export enum TicketsPageSize {
    full = 'full',
    compact = 'compact',
    onlyCheckout = 'onlyCheckout',
}

export enum CustomerPurchaseFlowTicketsPage {
    full = '/tickets',
    compact = '/ticketsCompactSize',
    onlyCheckout = '/onlyCheckout',
    reservedSeating = '/reservedTickets',
    series = '/series',
}
